import React from 'react';
import classNames from 'classnames';

import css from './IconTabNav.module.css';

const TabIcon = props => {
  const { rootClassName, className, children, viewBox = '0 0 24 24' } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox={viewBox}
      aria-hidden="true"
      focusable="false"
    >
      {children}
    </svg>
  );
};

/** List / clipboard — listing details */
export const IconTabDetails = props => (
  <TabIcon {...props}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 6h8M8 10h8M8 14h5M7 3h10a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"
    />
  </TabIcon>
);

/** Price tag — pricing / pricing & stock */
export const IconTabPricing = props => (
  <TabIcon {...props}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M20.59 13.41 13.42 20.58a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82Z"
    />
    <path strokeLinecap="round" strokeLinejoin="round" d="M7 7h.01" />
  </TabIcon>
);

/** Delivery truck */
export const IconTabDelivery = props => (
  <TabIcon {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M1 3h15v13H1V3Zm15 5h4l3 4v4h-7V8Z" />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5.5 21a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM18.5 21a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
    />
  </TabIcon>
);

/** Map pin — location */
export const IconTabLocation = props => (
  <TabIcon {...props}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 21s-7-5.686-7-11a7 7 0 1 1 14 0c0 5.314-7 11-7 11Z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 11.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
    />
  </TabIcon>
);

/** Calendar — availability */
export const IconTabAvailability = props => (
  <TabIcon {...props}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7 3v3M17 3v3M4 8h16M5 5h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z"
    />
  </TabIcon>
);

/** Image — photos */
export const IconTabPhotos = props => (
  <TabIcon {...props}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.5 11.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM3.5 16.5l4.5-4.5 3 3 3.5-4 6 5.5"
    />
  </TabIcon>
);

/** Palette — style / card style */
export const IconTabStyle = props => (
  <TabIcon {...props}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 3a9 9 0 1 0 0 18h1.5a2.5 2.5 0 0 0 0-5H12a9 9 0 0 1 0-13Z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.5 10.5h.01M10 7.5h.01M14 7.5h.01M16.5 10.5h.01"
    />
  </TabIcon>
);

/** Filled person — profile settings */
export const IconTabProfile = props => (
  <TabIcon {...props} className={classNames(css.filled, props.className)}>
    <circle cx="12" cy="8" r="3.6" />
    <path d="M5 20.25c0-3.45 3.13-6.25 7-6.25s7 2.8 7 6.25V21H5v-.75Z" />
  </TabIcon>
);

/** Envelope — contact details */
export const IconTabContact = props => (
  <TabIcon {...props}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 6h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1Z"
    />
    <path strokeLinecap="round" strokeLinejoin="round" d="m3.5 7 8.5 6 8.5-6" />
  </TabIcon>
);

/** Bank / building — payout details */
export const IconTabPayout = props => (
  <TabIcon {...props}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 10 12 4l9 6M5 10v8M9 10v8M15 10v8M19 10v8M3 20h18"
    />
  </TabIcon>
);

/** Credit card — payment methods */
export const IconTabPayment = props => (
  <TabIcon {...props}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 7h18a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1ZM2 11h20"
    />
  </TabIcon>
);

/** User badge — account type */
export const IconTabAccountType = props => (
  <TabIcon {...props}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM19 8v6M22 11h-6"
    />
  </TabIcon>
);

/** Gear — manage account */
export const IconTabManage = props => (
  <TabIcon {...props}>
    <circle cx="12" cy="12" r="3" strokeLinecap="round" strokeLinejoin="round" />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 2.5v2.2M12 19.3v2.2M21.5 12h-2.2M4.7 12H2.5M18.7 5.3l-1.6 1.6M6.9 17.1l-1.6 1.6M18.7 18.7l-1.6-1.6M6.9 6.9 5.3 5.3"
    />
  </TabIcon>
);
